import axios from 'axios'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.xsrfCookieName = "XSRF-TOKEN"
axios.defaults.xsrfHeaderName = "X-CSRF-Token"
axios.defaults.withCredentials = true
export default axios
